// TODO: type this — Vuex action context
type Ctx = any; // eslint-disable-line @typescript-eslint/no-explicit-any

interface NotificationState {
    message: string;
    actionLabel: string;
    action: (() => void) | null;
}

const NotificationStore = {
    namespaced: true,
    state: (): NotificationState => ({
        message: '',
        actionLabel: '',
        action: null,
    }),
    mutations: {
        set(
            state: NotificationState,
            { message, actionLabel, action }: { message: string; actionLabel: string; action: (() => void) | null },
        ): void {
            state.message = message;
            state.actionLabel = actionLabel;
            state.action = action;
        },
    },
    actions: {
        notify(
            { commit }: Ctx,
            {
                message,
                actionLabel = '',
                action = null,
            }: { message: string; actionLabel?: string; action?: (() => void) | null },
        ): void {
            commit('set', { message, actionLabel, action });
        },
        dismiss({ commit }: Ctx): void {
            commit('set', { message: '', actionLabel: '', action: null });
        },
        runAction({ state, commit }: Ctx): void {
            const action = state.action;
            commit('set', { message: '', actionLabel: '', action: null });
            if (action) action();
        },
    },
};

export default NotificationStore;
